module.exports = __webpack_public_path__ + "media/images/facebook-image-00e5bc8c3dc4c8d79f7de1e3ef5601a4.png";